export const pl = {
    languages: {
        cs: 'Czeski',
        de: 'Niemiecki',
        en: 'Angielski',
        es: 'Hiszpański',
        fr: 'Francuski',
        hr: 'Chorwacki',
        hu: 'Węgierski',
        it: 'Włoski',
        nl: 'Holenderski',
        pl: 'Polski',
        ru: 'Rosyjski',
        sk: 'Słowacki',
        tr: 'Turecki',
        uk: 'Ukraiński',
        undefined: 'Brak napisów',
    },
    player: {
        content: {
            notFound: { title: 'Błąd podczas ładowania elementu multimedialnego 😞' },
        },
        controls: {
            backwards: { title: '10s do tyłu' },
            buffering: { title: 'Ładowanie...' },
            captions: { title: 'Napisy' },
            forwards: { title: '10s do przodu' },
            fullscreen: { title: 'Pełny ekran' },
            pause: { title: 'Pauza' },
            play: { title: 'Odtwórz' },
            playlist: { title: 'Lista odtwarzania' },
            volume: { title: 'Głośność' },
        },
    },
};
